exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*styles for home content only*/\n.home-container {\n  background-color: transparent;\n}\n\n.center-alignment {\n  text-align: center;\n}\n\n.wav-studio-product-list {\n  text-align: center;\n  margin-top: 2%;\n  margin-bottom: 2%;\n}\n\n.wav-logo {\n  cursor: pointer;\n}\n\n.product-image {\n  display: inline-block;\n  cursor: pointer;\n  /* box-shadow: 0px 10px 22px 0px #000000; */\n}\n\n.footer-logo {\n  margin-bottom: 5%;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/home/home.component.css
// module id = zAkB
// module chunks = 1